// Money display helper. Amounts cross the wire as NUMERIC strings (never JS
// floats); rendering is the only place we let Intl parse them.

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

/** "$1,234.50" — em dash for null/undefined/unparseable. */
export function fmtMoney(amount: string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '—';
  const n = Number(amount);
  if (!Number.isFinite(n)) return '—';
  return usd.format(n);
}
